import i18n from '@/common/agent/i18n';
import * as yup from 'yup';

const getIdSchema = () => {
  return yup.string().required(i18n.t('form.id.error.required'));
};

//const PASSWORD_PATTERN = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,}$/;
const getPasswordSchema = () => {
  return yup
    .string()
    .required(i18n.t('form.password.error.required'))
    .min(6, i18n.t('form.password.error.min_length'))
    .max(20, i18n.t('form.password.error.max_length'));
  //.matches(PASSWORD_PATTERN, i18n.t('form.password.error.invalid_pattern'));
};

const getConfirmPasswordSchema = () => {
  return getPasswordSchema().oneOf([yup.ref('password')], i18n.t('form.password.error.not_match'));
};

export const getLoginFormSchema = () => {
  return yup
    .object()
    .shape({
      id: getIdSchema(),
      password: getPasswordSchema(),
    })
    .required();
};

export const getResetPasswordSchema = () => {
  return yup
    .object()
    .shape({
      password: getPasswordSchema(),
      passwordCheck: getConfirmPasswordSchema(),
    })
    .required();
};
